import { render, staticRenderFns } from "./StarterPack.vue?vue&type=template&id=6fc5ceee&scoped=true"
import script from "./StarterPack.vue?vue&type=script&lang=js"
export * from "./StarterPack.vue?vue&type=script&lang=js"
import style0 from "./StarterPack.vue?vue&type=style&index=0&id=6fc5ceee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc5ceee",
  null
  
)

export default component.exports